export const DEBUG_CAPACITE = {
  id: 'd0f0feff-27f0-4458-8af9-8d1713456111',
  bilanSommaire: {
    revenuAnnuelBrut: 150000.0,
    revenuNet: 2500.0,
    codeFrequenceRevenuNet: 'BIMENSUEL',
    carteCredit: 0.0,
    codeFrequenceCarteCredit: null,
    margeCredit: 0.0,
    codeFrequenceMargeCredit: null,
    pretPersonnel: 0.0,
    codeFrequencePretPersonnel: null,
    pretAuto: 0.0,
    codeFrequencePretAuto: null,
    autrePret: 0.0,
    codeFrequenceAutrePret: null,
    typeFrequence: null,
    rempli: true
  },
  miseDeFonds: 40000.0,
  depensesMensuels: [],
  valeurProprieteMaximale: 100000,
  versementMensuelMaximal: 600,
  primeAssureurHypothecaireMaximale: 100,
  versementMensuelRealiste: 450,
  valeurProprieteRealiste: 80000,
  primeAssureurHypothecaireRealiste: 60,
  indicateurLimiteMontantVersement: 'N',
  montantLimiteVersementMensuel: null,
  montantPretMaximal: 80000,
  montantPretRealiste: 60000,
  amortissement: {
    id: '26c31d90-e8b2-4725-8fe8-42596253d900',
    duree: 25,
    frequence: 'ANNUEL',
    descriptionCourteFrancais: '25 ans',
    descriptionCourteAnglais: '25-year',
    rempli: true
  },
  produitTerme: {
    id: 'fdc8ad95-bf53-49bf-b51a-e8edcadd25eb',
    code: 'FIXEFERME',
    duree: 5,
    frequence: 'ANNUEL',
    descriptionCourteFrancais: 'Taux 5 ans fixe',
    descriptionCourteAnglais: '5-year fixed rate',
    expressionXpath: '/data/residential-mortgage/fixed/terms/term[desc_fr="5 ans"]/closed',
    rempli: true
  },
  taux: 5.69,
  paiementsHypothecaires: null,
  codeFrequencePaiementsHypothecaires: null,
  indicateurMontantTotalDepenses: 'O',
  indicateurCarteCredit: 'O',
  montantTotalDepenses: 1233.0,
  typePropriete: null,
  typeCapacite: 'PME_REMPLACER',
  montantLimiteRempli: false,
  idAmortissement: '26c31d90-e8b2-4725-8fe8-42596253d900',
  idProduitTerme: 'fdc8ad95-bf53-49bf-b51a-e8edcadd25eb',
  depensesResidenceCourante: {
    taxesScolaires: 35.0,
    codeFrequenceTaxesScolaires: 'MENSUEL',
    taxesMunicipales: 160.0,
    codeFrequenceTaxesMunicipales: 'MENSUEL',
    coutsEnergie: 130.0,
    codeFrequenceCoutsEnergie: 'MENSUEL',
    fraisCopropriete: 0.0,
    codeFrequenceFraisCopropriete: 'MENSUEL',
    paiementsHypothecaires: 200,
    codeFrequencePaiementsHypothecaires: 'MENSUEL'
  },
  depensesEstimeesCapaciteRealiste: {
    taxesScolaires: 35.0,
    codeFrequenceTaxesScolaires: 'MENSUEL',
    taxesMunicipales: 160.0,
    codeFrequenceTaxesMunicipales: 'MENSUEL',
    coutsEnergie: 130.0,
    codeFrequenceCoutsEnergie: 'MENSUEL',
    fraisCopropriete: 0.0,
    codeFrequenceFraisCopropriete: 'MENSUEL'
  },
  depensesEstimeesCapaciteMaximale: {
    taxesScolaires: 35.0,
    codeFrequenceTaxesScolaires: 'MENSUEL',
    taxesMunicipales: 160.0,
    codeFrequenceTaxesMunicipales: 'MENSUEL',
    coutsEnergie: 130.0,
    codeFrequenceCoutsEnergie: 'MENSUEL',
    fraisCopropriete: 0.0,
    codeFrequenceFraisCopropriete: 'MENSUEL'
  }
};
